

import React, { useState } from "react";
import axios from "axios";
import '../../CSS/Global.css'; // 🔁 Link your CSS here

function ImageModalEquip({ show, handleClose, images, onImageSelect, multiple, setImages }) {
    const [selectedImages, setSelectedImages] = useState([]);
    const [activeTab, setActiveTab] = useState("media");
    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadSuccess, setUploadSuccess] = useState(false);

    const handleImageClick = (image) => {
        setSelectedImages([image]);
    };

    const handleConfirm = () => {
        onImageSelect(multiple ? selectedImages : selectedImages[0]);
        handleClose();
    };

    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        if (file) handleImageUpload(file);
    };

    const handleImageUpload = async (file) => {
        const formData = new FormData();
        formData.append("image", file);
        setUploading(true);
        setUploadProgress(0);
        try {
            const res = await axios.post("https://100billionrealestate.com/api/images/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (event) => {
                    const percent = Math.round((event.loaded * 100) / event.total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 201) {
                const all = await axios.get("https://100billionrealestate.com/api/images");
                setImages(all.data);
                setUploadSuccess(true);
            }
        } catch (err) {
            console.error("Upload failed", err);
        } finally {
            setUploading(false);
            setTimeout(() => setUploadSuccess(false), 3000);
        }
    };

    const handleImageDelete = async (id) => {
        try {
            await axios.delete(`https://100billionrealestate.com/api/images/${id}`);
            const all = await axios.get("https://100billionrealestate.com/api/images");
            setImages(all.data);
        } catch (err) {
            console.error("Delete failed", err);
        }
    };

    if (!show) return null;

    return (
        <div className="custom-modal-overlayomsprod">
            <div className="custom-modal-contentomsprod">
                <div className="modal-headeromsprod">
                    <h3>Select Image</h3>
                    <button onClick={handleClose} className="close-btn">×</button>
                </div>
                 <div className="modal-tabsomsprodmain">
                <button type="button" className={activeTab === 'upload' ? 'active' : ''} onClick={() => setActiveTab('upload')}>
                    Upload Files
                </button>
                <button type="button" className={activeTab === 'media' ? 'active' : ''} onClick={() => setActiveTab('media')}>
                    Media Library
                </button>
                </div>


                <div className="modal-bodyomsprod">
                    {activeTab === 'upload' ? (
                        <div className="upload-sectionomsprod" onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                            onDragLeave={(e) => { e.preventDefault(); setIsDragging(false); }}
                            onDrop={(e) => { e.preventDefault(); setIsDragging(false); handleFileInputChange(e); }}
                        >
                            <label className="file-labelomsprod">
                                Select File
                                <input type="file" onChange={handleFileInputChange} hidden />
                            </label>
                            <p>Drop files to upload</p>
                            <p>Max size: 1 MB</p>

                            {uploading && <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>}
                            {uploadSuccess && <div className="success-msg">✅ Uploaded successfully!</div>}
                        </div>
                    ) : (
                        <div className="media-galleryomsprod">
                            {images.map((image, idx) => (
                                <div
                                    key={idx}
                                    className={`image-wrapperomsprod ${selectedImages.includes(image) ? 'selected' : ''}`}
                                    onClick={() => handleImageClick(image)}
                                >
                                    <img src={`https://100billionoms.top${image.url}`} alt="media" />
                                    <button className="delete-btnomsprod" onClick={(e) => { e.stopPropagation(); handleImageDelete(image.id); }}>×</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="modal-footeromsprod">
                    <button onClick={handleConfirm} className="confirm-btnomsprod">Confirm</button>
                </div>
            </div>
        </div>
    );
}

export default ImageModalEquip;
